import L from "leaflet";
import store from "../redux/store";
import {
  setNavHobo,
  setNavSpark,
  setNavSubway,
  setNavTram,
  setNavTrolley,
  setNavCharger,
  setNavCycleways,
  setNavGreenCorridor1,
  setNavGreenCorridor2,
  setNavGreenCorridor3,
  setNavBus,
  setNavReconstructionsPermanent,
  setNavReconstructionsTemporary,
} from "../redux/actions/navigation-actions";
import {
  setTMStaticFilteredData,
  setTBStaticFilteredData,
  setBStaticFilteredData,
} from "../redux/actions/static-data-actions";
import {
  setSelectedLine,
  changeMapCenter,
  setMapZoom,
} from "../redux/actions/shared-actions";
import { batch } from "react-redux";
import i18n from "../i18n";

/**
 * Contains shared functions.
 * @namespace shared
 * @category Services
 */
// eslint-disable-next-line
const shared = {};
//used for the namespace in the documentation

//kanachkova - get reconstruction icons
/**
 * Returns icon for reconstruction
 * @memberof shared
 * @function getReconstructionIcon
 * @returns Leaflet icon
 */
export const getReconstructionIcon = () => {
  return L.icon({
    iconUrl: process.env.PUBLIC_URL + "/icons/temporaryOrganization.webp",
    iconSize: [35, 35],
    iconAnchor: [10, 20],
  });
};

//avl icons
/**
 * Returns icon for trams
 * @memberof shared
 * @function getTramIcon
 * @returns Leaflet icon
 */
export const getTramIcon = () => {
  return L.icon({
    iconUrl: process.env.PUBLIC_URL + "/icons/tram.webp",
    iconSize: [35, 35],
    iconAnchor: [10, 20],
  });
};
/**
 * Returns stop for trams stop
 * @memberof shared
 * @function getTramStopIcon
 * @returns Leaflet icon
 */
export const getTramStopIcon = () => {
  return L.icon({
    iconUrl: process.env.PUBLIC_URL + "/icons/tram-stop.webp",
    iconSize: [25, 25],
    iconAnchor: [10, 20],
  });
};
/**
 * Returns icon for trolleys and ebuses
 * @memberof shared
 * @function getTrolleyIcon
 * @returns Leaflet icon
 */
export const getTrolleyIcon = () => {
  return L.icon({
    iconUrl: process.env.PUBLIC_URL + "/icons/trolley.webp",
    iconSize: [35, 35],
    iconAnchor: [10, 20],
  });
};
/**
 * Returns icon for trolleys and ebuses stop
 * @memberof shared
 * @function getTrolleyStopIcon
 * @returns Leaflet icon
 */
export const getTrolleyStopIcon = () => {
  return L.icon({
    iconUrl: process.env.PUBLIC_URL + "/icons/trolley-stop.webp",
    iconSize: [25, 25],
    iconAnchor: [10, 20],
  });
};
/**
 * Returns icon for buses
 * @memberof shared
 * @function getBusIcon
 * @returns Leaflet icon
 */
export const getBusIcon = () => {
  return L.icon({
    iconUrl: process.env.PUBLIC_URL + "/icons/bus.webp",
    iconSize: [35, 35],
    iconAnchor: [10, 20],
  });
};
/**
 * Returns icon for buses stop
 * @memberof shared
 * @function getBusStopIcon
 * @returns Leaflet icon
 */
export const getBusStopIcon = () => {
  return L.icon({
    iconUrl: process.env.PUBLIC_URL + "/icons/bus-stop.webp",
    iconSize: [25, 25],
    iconAnchor: [10, 20],
  });
};

//kanachkova - return cluster icon for reconstruction
/**
 * Returns cluster icon for reconstruction
 * @memberof shared
 * @function createClusterReconstructionIcon
 * @param {array} cluster leaflet cluster of markers
 
 * @returns Leaflet cluster icon
 */
export const createClusterReconstructionIcon = function (cluster) {
  return L.divIcon({
    html: `<span style="color:${
      window.localStorage.getItem("mapName") === "Carto.DarkMatter"
        ? "white"
        : "black"
    }">${cluster.getChildCount()}</span>`,
    className: "tram-cluster-icon",
    iconSize: L.point(35, 35, true),
  });
};

/**
 * Returns cluster icon for trams
 * @memberof shared
 * @function createClusterTramIcon
 * @param {array} cluster leaflet cluster of markers
 
 * @returns Leaflet cluster icon
 */
export const createClusterTramIcon = function (cluster) {
  return L.divIcon({
    html: `<span style="color:${
      window.localStorage.getItem("mapName") === "Carto.DarkMatter"
        ? "white"
        : "black"
    }">${cluster.getChildCount()}</span>`,
    className: "tram-cluster-icon",
    iconSize: L.point(35, 35, true),
  });
};
/**
 * Returns cluster icon for trams stops
 
 * @memberof shared
 * @function createClusterTramStopIcon
 * @param {array} cluster leaflet cluster of markers
 * @returns Leaflet cluster icon
 */
export const createClusterTramStopIcon = function (cluster) {
  return L.divIcon({
    html: `<span style="color:${
      window.localStorage.getItem("mapName") === "Carto.DarkMatter"
        ? "white"
        : "black"
    }">${cluster.getChildCount()}</span>`,
    className: "tram-stop-cluster-icon",
    iconSize: L.point(25, 25, true),
  });
};
/**
 * Returns cluster icon for trolleys and ebuses
 
 * @memberof shared
 * @function createClusterTrolleyIcon
 * @param {array} cluster leaflet cluster of markers
 * @returns Leaflet cluster icon
 */
export const createClusterTrolleyIcon = function (cluster) {
  return L.divIcon({
    html: `<span style="color:${
      window.localStorage.getItem("mapName") === "Carto.DarkMatter"
        ? "white"
        : "black"
    }">${cluster.getChildCount()}</span>`,
    className: "trolley-cluster-icon",
    iconSize: L.point(35, 35, true),
  });
};
/**
 * Returns cluster icon for trolleys and ebuses stops
 
 * @memberof shared
 * @function createClusterTrolleyStopIcon
 * @param {array} cluster leaflet cluster of markers
 * @returns Leaflet cluster icon
 */
export const createClusterTrolleyStopIcon = function (cluster) {
  return L.divIcon({
    html: `<span style="color:${
      window.localStorage.getItem("mapName") === "Carto.DarkMatter"
        ? "white"
        : "black"
    }">${cluster.getChildCount()}</span>`,
    className: "trolley-stop-cluster-icon",
    iconSize: L.point(25, 25, true),
  });
};
/**
 * Returns cluster icon for buses
 
 * @memberof shared
 * @function createClusterBusIcon
 * @param {array} cluster leaflet cluster of markers
 * @returns Leaflet cluster icon
 */
export const createClusterBusIcon = function (cluster) {
  return L.divIcon({
    html: `<span style="color:${
      window.localStorage.getItem("mapName") === "Carto.DarkMatter"
        ? "white"
        : "black"
    }">${cluster.getChildCount()}</span>`,
    className: "bus-cluster-icon",
    iconSize: L.point(35, 35, true),
  });
};
/**
 * Returns cluster icon for buses stops
 
 * @memberof shared
 * @function createClusterBusStopIcon
 * @param {array} cluster leaflet cluster of markers
 * @returns Leaflet cluster icon
 */
export const createClusterBusStopIcon = function (cluster) {
  return L.divIcon({
    html: `<span style="color:${
      window.localStorage.getItem("mapName") === "Carto.DarkMatter"
        ? "white"
        : "black"
    }">${cluster.getChildCount()}</span>`,
    className: "bus-stop-cluster-icon",
    iconSize: L.point(25, 25, true),
  });
};
//

//hobo icons
/**
 * Returns icon for hobo
 
 * @memberof shared
 * @function getHoboIcon
 * @returns Leaflet icon
 */
export const getHoboIcon = () => {
  return L.icon({
    iconUrl: process.env.PUBLIC_URL + "/icons/hobo.webp",
    iconSize: [35, 35],
    iconAnchor: [10, 20],
  });
};
/**
 * Returns cluster icon for hobo
 
 * @memberof shared
 * @function createClusterHoboIcon
 * @param {array} cluster leaflet cluster of markers
 
 * @returns Leaflet cluster icon
 */
export const createClusterHoboIcon = function (cluster) {
  return L.divIcon({
    html: `<span style="color:${
      window.localStorage.getItem("mapName") === "Carto.DarkMatter"
        ? "white"
        : "black"
    }">${cluster.getChildCount()}</span>`,
    className: "hobo-cluster-icon",
    iconSize: L.point(35, 35, true),
  });
};
//

//spark icons
/**
 * Returns icon for spark
 
 * @memberof shared
 
 * @function getSparkIcon
 * @returns Leaflet icon
 */
export const getSparkIcon = () => {
  return L.icon({
    iconUrl: process.env.PUBLIC_URL + "/icons/spark.webp",
    iconSize: [40, 40],
    iconAnchor: [10, 20],
  });
};
/**
 * Returns cluster icon for spark
 
 * @memberof shared
 * @function createClusterSparkIcon
 * @param {array} cluster leaflet cluster of markers
 
 * @returns Leaflet cluster icon
 */
export const createClusterSparkIcon = function (cluster) {
  return L.divIcon({
    html: `<span style="color:${
      window.localStorage.getItem("mapName") === "Carto.DarkMatter"
        ? "white"
        : "black"
    }">${cluster.getChildCount()}</span>`,
    className: "spark-cluster-icon",
    iconSize: L.point(40, 40, true),
  });
};
//

//charger icons
/**
 * Returns icon for charger
 
 * @memberof shared
 
 * @function getChargerIcon
 * @returns Leaflet icon
 */
export const getChargerIcon = () => {
  return L.icon({
    iconUrl: process.env.PUBLIC_URL + "/icons/charger.webp",
    iconSize: [35, 35],
    iconAnchor: [10, 20],
  });
};
/**
 * Returns cluster icon for charger
 
 * @memberof shared
 * @function createClusterChargerIcon
 * @param {array} cluster leaflet cluster of markers
 
 * @returns Leaflet cluster icon
 */
export const createClusterChargerIcon = function (cluster) {
  return L.divIcon({
    html: `<span>${cluster.getChildCount()}</span>`,
    className: "charger-cluster-icon",
    iconSize: L.point(35, 35, true),
  });
};
//

//subway
/**
 * Returns icon for subway stations
 
 * @memberof shared
 
 * @function getSubwayStationIcon
 * @returns Leaflet icon
 */
export const getSubwayStationIcon = () => {
  return L.icon({
    iconUrl: process.env.PUBLIC_URL + "/icons/subway.webp",
    iconSize: [20, 20],
    iconAnchor: [10, 20],
  });
};
/**
 * Returns cluster icon for subway stations
 
 * @memberof shared
 * @function createClusterSubwayStationIcon
 * @param {array} cluster leaflet cluster of markers
 
 * @returns Leaflet cluster icon
 */
export const createClusterSubwayStationIcon = (cluster) => {
  return L.divIcon({
    html: `<span style="color:${
      window.localStorage.getItem("mapName") === "Carto.DarkMatter"
        ? "white"
        : "black"
    }">${cluster.getChildCount()}</span>`,
    className: "subway-cluster-icon",
    iconSize: L.point(20, 20, true),
  });
};
//
/**
 * Extracts polylines from a string.
 
 * @memberof shared
 * @function extractPolylineFromWKT
 
 * @param {string} value string of polylines
 * @param {boolean} isLatLng based on this the extraction is secured to be in the correct 'lat:...,lng:...' format
 * @returns Array of latitudes and longitudes.
 */
export const extractPolylineFromWKT = (value, isLatLng) => {
  let splitted = value.split("LINESTRING");
  let collection = splitted[1]
    .replace(/\(/g, "")
    .replace(/\)/g, "")
    .trim()
    .split(",");

  let resultArr = [];

  for (let item of collection) {
    let coordinates = item.trim().split(" ");
    resultArr.push(
      isLatLng
        ? { lat: Number(coordinates[0]), lng: Number(coordinates[1]) }
        : { lat: Number(coordinates[1]), lng: Number(coordinates[0]) }
    );
  }

  return resultArr;
};
/**
 * Finds the center of a given line, based on its stops.
 * @function calculateCenterLine
 * @memberof shared
 *
 * @param {array} stops - A collection of stops.
 * @returns Array  with lat and lng values
 */
export const calculateCenterLine = (stops) => {
  let result = {
    lat: 0,
    lng: 0,
  };

  for (let s of stops) {
    if (s.location) {
      result.lat += s.location.lat;
      result.lng += s.location.lng;
    } else {
      result.lat += s.latitude;
      result.lng += s.longitude;
    }
  }

  result.lat /= stops.length;
  result.lng /= stops.length;

  return [result.lat, result.lng];
};
/**
 * Transforms a line to a translated string.
 * @memberof shared
 * @function translateLine
 * @param {string} line the line string ex "TM11"
 * @returns Translated line string.
 */
export const translateLine = (line) => {
  if (line) {
    if (!line.includes("_")) {
      const [lineType, lineNumber] = line.match(/[A-Z]+|[0-9A-ZА-Я]+/g);
      return i18n.t(lineType) + " " + lineNumber;
    } else {
      return i18n.t(line);
    }
  }
  return line;
};
/**
 * Used in the lines-autocomplete component in the navigation-drawer component.
 * When an option is picked from the autocomplete it dispatches correct filtered data based on the label and the value
 
 * @memberof shared
 * @function handleLineAutocompleteChange
 * @param {string} newValue the new selected value
 * @param {string} label the label of the lines-autocomplete component
 
 */
export const handleLineAutocompleteChange = (newValue, label) => {
  batch(() => {
    if (label === "TRAMS") {
      store.dispatch(setNavTram(true));
      store.dispatch(setNavTrolley(false));
      store.dispatch(setNavBus(false));
      if (newValue !== "ALL_TRAMS") {
        store.dispatch(
          setTMStaticFilteredData(
            store
              .getState()
              .staticData.TMData.filter((x) => x.line === newValue)
          )
        );
        store.dispatch(
          changeMapCenter(
            calculateCenterLine(
              store
                .getState()
                .staticData.TMData.filter((x) => x.line === newValue)[0]
                .direction0.stops
            )
          )
        );
      } else {
        store.dispatch(
          setTMStaticFilteredData(store.getState().staticData.TMData)
        );
        store.dispatch(changeMapCenter([42.696889, 23.320856]));
      }
    }
    if (label === "TROLLEYS_AND_EBUSES") {
      store.dispatch(setNavTram(false));
      store.dispatch(setNavTrolley(true));
      store.dispatch(setNavBus(false));
      if (newValue !== "ALL_TROLLEYS_AND_EBUSES") {
        store.dispatch(
          setTBStaticFilteredData(
            store
              .getState()
              .staticData.TBData.filter((x) => x.line === newValue)
          )
        );
        store.dispatch(
          changeMapCenter(
            calculateCenterLine(
              store
                .getState()
                .staticData.TBData.filter((x) => x.line === newValue)[0]
                .direction0.stops
            )
          )
        );
      } else {
        store.dispatch(
          setTBStaticFilteredData(store.getState().staticData.TBData)
        );
        store.dispatch(changeMapCenter([42.696889, 23.320856]));
      }
    }
    if (label === "BUSES") {
      store.dispatch(setNavTram(false));
      store.dispatch(setNavTrolley(false));
      store.dispatch(setNavBus(true));
      if (newValue !== "ALL_BUSES") {
        store.dispatch(
          setBStaticFilteredData(
            store.getState().staticData.BData.filter((x) => x.line === newValue)
          )
        );
        store.dispatch(
          changeMapCenter(
            calculateCenterLine(
              store
                .getState()
                .staticData.BData.filter((x) => x.line === newValue)[0]
                .direction0.stops
            )
          )
        );
      } else {
        store.dispatch(
          setBStaticFilteredData(store.getState().staticData.BData)
        );
        store.dispatch(changeMapCenter([42.696889, 23.320856]));
      }
    }
    store.dispatch(setMapZoom(13));
    store.dispatch(setNavSubway(false));
    store.dispatch(setSelectedLine(newValue));
  });
};
/**
 * It is used in the navigation-tabs component.
 * Dispatches the specific actions related to the clicked navigation tab.
 
 * @memberof shared
 * @function setTabsOnDrawerOpen
 * @param {string} type the title of clicked navigation tab
 
 */
export const setTabsOnDrawerOpen = (type) => {
  switch (type) {
    case "GREEN_INFRASTRUCTURE":
      batch(() => {
        store.dispatch(setNavBus(false));
        store.dispatch(setNavTram(false));
        store.dispatch(setNavTrolley(false));
        store.dispatch(setNavSubway(false));
        store.dispatch(setNavHobo(false));
        store.dispatch(setNavCharger(false));
        store.dispatch(setNavSpark(false));
        store.dispatch(setNavCycleways(false));
        store.dispatch(setNavGreenCorridor1(true));
        store.dispatch(setNavGreenCorridor2(true));
        store.dispatch(setNavGreenCorridor3(true));
        //kanachkova
        store.dispatch(setNavReconstructionsTemporary(false));
        store.dispatch(setNavReconstructionsPermanent(false));
      });
      break;
    case "ALTERNATIVE_TRANSIT":
      batch(() => {
        store.dispatch(setNavBus(false));
        store.dispatch(setNavTram(false));
        store.dispatch(setNavTrolley(false));
        store.dispatch(setNavSubway(false));
        store.dispatch(setNavHobo(true));
        store.dispatch(setNavCharger(true));
        store.dispatch(setNavSpark(true));
        store.dispatch(setNavCycleways(true));
        store.dispatch(setNavGreenCorridor1(false));
        store.dispatch(setNavGreenCorridor2(false));
        store.dispatch(setNavGreenCorridor3(false));
        //kanachkova
        store.dispatch(setNavReconstructionsTemporary(false));
        store.dispatch(setNavReconstructionsPermanent(false));
      });
      break;
    case "PUBLIC_TRANSIT":
      batch(() => {
        store.dispatch(setNavBus(false));
        store.dispatch(setNavTram(true));
        store.dispatch(setNavTrolley(true));
        store.dispatch(setNavSubway(true));
        store.dispatch(setNavHobo(false));
        store.dispatch(setNavCharger(false));
        store.dispatch(setNavSpark(false));
        store.dispatch(setNavCycleways(false));
        store.dispatch(setNavGreenCorridor1(false));
        store.dispatch(setNavGreenCorridor2(false));
        store.dispatch(setNavGreenCorridor3(false));
        //kanachkova
        store.dispatch(setNavReconstructionsTemporary(false));
        store.dispatch(setNavReconstructionsPermanent(false));
      });
      break;
    //kanachkova
    case "RECONSTRUCTIONS":
      batch(() => {
        store.dispatch(setNavReconstructionsTemporary(true));
        store.dispatch(setNavReconstructionsPermanent(true));
        store.dispatch(setNavBus(false));
        store.dispatch(setNavTram(false));
        store.dispatch(setNavTrolley(false));
        store.dispatch(setNavSubway(false));
        store.dispatch(setNavHobo(false));
        store.dispatch(setNavCharger(false));
        store.dispatch(setNavSpark(false));
        store.dispatch(setNavCycleways(false));
        store.dispatch(setNavGreenCorridor1(false));
        store.dispatch(setNavGreenCorridor2(false));
        store.dispatch(setNavGreenCorridor3(false));
      });
      break;
    default:
      batch(() => {
        store.dispatch(setNavBus(false));
        store.dispatch(setNavTram(false));
        store.dispatch(setNavTrolley(false));
        store.dispatch(setNavSubway(false));
        store.dispatch(setNavHobo(false));
        store.dispatch(setNavCharger(false));
        store.dispatch(setNavSpark(false));
        store.dispatch(setNavCycleways(false));
        store.dispatch(setNavGreenCorridor1(false));
        store.dispatch(setNavGreenCorridor2(false));
        store.dispatch(setNavGreenCorridor3(false));
      });
  }
  store.dispatch(changeMapCenter([42.696889, 23.320856]));
  store.dispatch(setMapZoom(13));
};
